const getNewPageOnDelete = (page, length) => {
  try {
    if (length <= 1 && page > 1) {
      return page - 1
    }

    return page
  } catch (e) {
    console.log(e)
    return page
  }
}

export default getNewPageOnDelete
